<template>
    <div class="flex flex-col pb-2">
        <div class="flex w-full justify-between">
            <div title="The day on which the next invoice should be sent. Calculated to avoid weekends and holidays." class="whitespace-prewrap font-semibold tracking-wide hover:cursor-help text-gray-800 pr-0">
                Next Invoice Day:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="pl-0">
                {{ targetDueDay }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Days Until Next Invoice Day:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div class="flex items-center justify-center" :class="dateStyling">
                {{ engagement.days_until_target_invoice_day }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Target Due Date:
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div >
                {{ targetDueDate }}
            </div>
        </div>
        <div class="flex w-full justify-between">
            <div class="whitespace-prewrap font-semibold tracking-wide  text-gray-800 pr-0">
                Last Invoice Sent (Due):
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>
            <div @click="showAllInvoices"  v-if="mostRecentInvoice">
                <span class="underline hover:cursor-pointer">{{ mostRecentInvoice.invoice_number }}:</span> {{ formatDateTwoDigitYear(mostRecentInvoice.invoice_date) }} ({{ formatDateMonthAndDay(mostRecentInvoice.due_date) }})
            </div>
        <base-modal 
        :is-form-visible="viewAllInvoices" @close="closeAllInvoices"
            >
              <template v-slot:header>
                Retainer Invoices for {{ client.client_name }}:
              </template>
              <template v-slot:body>
                <div class="max-h-[95vh] overflow-auto">
                    <SimpleInvoiceTable :invoices="engagement.invoices" />
                </div>
              </template>
        </base-modal>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';
import { formatDateTwoDigitYear, formatDateWithWeekday, formatDateMonthAndDay } from '@/composables/formatDate';
import { formatCurrency } from '@/composables/formatCurrency';
import SimpleInvoiceTable from '../invoice_components/SimpleInvoiceTable.vue';

const props = defineProps([
    'engagement',
    'client'
])

const startDate = computed(() => {
    return formatDateTwoDigitYear(props.engagement.start_date)
})

const endDate = computed(() => {
    return formatDateTwoDigitYear(props.engagement.end_date)
})

const retainerAmount = computed(() => {
    return formatCurrency(props.engagement.retainer_amount)
})

const viewAllInvoices = ref(false)


function showAllInvoices(){
    viewAllInvoices.value = true
}

function closeAllInvoices(){
    viewAllInvoices.value = false
}

const targetDueDay = computed(() => {
    if(props.engagement.target_invoice_day){
        return formatDateWithWeekday(props.engagement.target_invoice_day.target_day.replace(/-/g, '/'))
    } else {
        return "--"
    }
})

const differentDueDays = computed(() => {
    if(props.engagement.target_invoice_day){
        let returnString = ""
        if(props.engagement.target_invoice_day.due_date != props.engagement.target_invoice_day.initial_due_date){
            returnString += `(DD: ${formatDateWithWeekday(props.engagement.target_invoice_day.initial_due_date.replace(/-/g, '/'))}) `
        }
        if(props.engagement.target_invoice_day.target_day != props.engagement.target_invoice_day.initial_day){
            returnString += `(ID: ${formatDateWithWeekday(props.engagement.target_invoice_day.initial_day.replace(/-/g, '/'))}) `
        }
        return returnString
    } else {
        return null
    }
})

const dateStyling = computed(() => {
    if(props.engagement.target_invoice_day_due_status === "good") {
        return 
    } else if(props.engagement.target_invoice_day_due_status === "overdue") {
        return "bg-[#FFFF01] px-5"
    } else if(props.engagement.target_invoice_day_due_status === "due_soon")  {
        return  "bg-[#8EA9DA] px-5"
    } else if(props.engagement.target_invoice_day_due_status === "needs_sending")  {
        return  "bg-[#bbf7d0] px-5"
    }
    return ""
})

const targetDueDate = computed(() => {
    if(props.engagement.target_due_date){
        if(props.engagement.target_due_date === 1){
            return `${props.engagement.target_due_date}st`
        } else if (props.engagement.target_due_date === 2){
            return `${props.engagement.target_due_date}nd`
        } else {
            return `${props.engagement.target_due_date}th`
        } 
    } else {
        return '--'
    }
})

const mostRecentInvoice = computed(() => {
    if(props.engagement.invoices.length > 0){
        let lastInvoice = props.engagement.invoices.filter((invoice) => invoice.sent_date)[0]
        return lastInvoice
    } else {
        return null
    }
})

</script>